export const LOGIN_API = '/api/security/login'
export const GET_CAPTCHA_API = '/api/security/captcha'
